<template>
  <lk-table
      border
      :columns='columns'
      :data='resTable'
      ></lk-table>
</template>
<script>
import utils from '../../libs/utils';

export default {
  name: 'ReturnExpand',
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      columns: [
        {
          title: 'ID',
          minWidth: 58,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '商品编码',
          minWidth: 116,
          key: 'serialCode',
        },
        {
          title: '通用名称',
          minWidth: 116,
          key: 'approvedName',
        },
        {
          title: '商品名称',
          minWidth: 116,
          key: 'goodsName',
        },
        {
          title: '数量',
          minWidth: 116,
          key: 'num',
        },
        {
          title: '单价',
          minWidth: 116,
          key: 'realPrice',
        },
        {
          title: '规格',
          minWidth: 116,
          key: 'spec',
        },
        {
          title: '单位',
          minWidth: 116,
          key: 'minPkgUnitName',
        },
        {
          title: '剂型',
          minWidth: 116,
          key: 'dosageFormName',
        },
        {
          title: '生产企业',
          minWidth: 116,
          key: 'producer',
        },
      ],
    };
  },
  computed: {
    resTable() {
      return this.tableData.map((item) => {
        const result = {};
        utils.exchangeTable(item, result);
        return result;
      });
    },
  },
};
</script>
